import { render, staticRenderFns } from "./block-losses-inputs.vue?vue&type=template&id=6b0cb1c5&scoped=true&"
import script from "./block-losses-inputs.vue?vue&type=script&lang=ts&"
export * from "./block-losses-inputs.vue?vue&type=script&lang=ts&"
import style0 from "./block-losses-inputs.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./block-losses-inputs.vue?vue&type=style&index=1&id=6b0cb1c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0cb1c5",
  null
  
)

export default component.exports